import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import Expand from '@lt/components/icons-react/rebrand/Expand';
import Shrink from '@lt/components/icons-react/rebrand/Shrink';
import { i18n } from '@lt/localization';

import styles from './fullscreenControlButton.module.css';

const YMapControlButton = loadReactComponent(
  'YMapControlButton',
  loadModulePromise,
);

interface FullscreenControlButtonProps {
  isExpanded: boolean;
  toggleHandler: () => void;
  expandText?: string;
  collapseText?: string;
}

const FullscreenControlButton = (props: FullscreenControlButtonProps) => {
  const {
    isExpanded,
    expandText = i18n.t('map.controls.expand'),
    collapseText = i18n.t('map.controls.collapse'),
    toggleHandler,
  } = props;

  const ResizeIcon = isExpanded ? Shrink : Expand;

  return (
    <YMapControlButton onClick={toggleHandler}>
      <div className={styles.buttonContent}>
        <ResizeIcon className={styles.icon} />
        {isExpanded ? (
          <span>{collapseText}</span>
        ) : (
          <span>{expandText}</span>
        )}{' '}
      </div>
    </YMapControlButton>
  );
};

export default FullscreenControlButton;
